import * as Sentry from '@sentry/browser'

const IGNORED_BREADCRUMB_FETCH_HOSTS = [
  'ph.thatch.ai',
  'ph.thatch.com',
  'sgmt-api.thatch.ai',
  'sgmt-api.thatch.com',
  'sgmt-cdn.thatch.ai',
  'sgmt-cdn.thatch.com',
]

export function initSentry () {
  const dsn = document.head.querySelector<HTMLMetaElement>('meta[name="sentry:dsn"]')?.content

  if (!dsn) {
    return
  }

  const environment = document.head.querySelector<HTMLMetaElement>('meta[name="sentry:rails-env"]')?.content
  const release = document.head.querySelector<HTMLMetaElement>('meta[name="sentry:revision"]')?.content
  const userId = document.head.querySelector<HTMLMetaElement>('meta[name="sentry:user-id"]')?.content

  Sentry.init({
    dsn,
    environment: environment || 'development',
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration(),
    ],
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/(?!(ph|sgmt-cdn|sgmt-api)\.thatch\.(ai|com)(\/|$))[\w-.]+\.thatch\.(ai|com)(\/.*)?$/,
      /^https:\/\/(\w+[.])?thatchcloud\.com/
    ],
    tracesSampler: samplingContext => {
    // always inherit
      if (samplingContext.parentSampled !== undefined) { return samplingContext.parentSampled }

      // default sample rate of 10%
      return 0.1
    },
    beforeBreadcrumb: (breadcrumb) => {
      const isFetch = breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr'

      if (isFetch && IGNORED_BREADCRUMB_FETCH_HOSTS.some(host => breadcrumb.data?.url?.includes(host))) {
        return null
      }

      return breadcrumb
    }
  })

  if (userId) {
    Sentry.setUser({ id: userId })
  }
}
